import Flickity from '../flickity.pkgd.min.js';

export const ThumbnailSlider = {
    initSlider(carousel) {
        var flkty = new Flickity(carousel, {
            cellSelector: '.slide',
            lazyLoad: true,
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: 1,
            prevNextButtons: false,
            draggable: false
        });

        var prevButton = carousel.querySelector('.thumbnail-next'),
            nextButton = carousel.querySelector('.thumbnail-prev');

        prevButton.addEventListener('click', function (e) {
            e.preventDefault();
            flkty.previous();
        });

        nextButton.addEventListener('click', function (e) {
            e.preventDefault();
            flkty.next();
        });
    },

    init() {
        var carousels = document.querySelectorAll('.thumb-nail-slider');

        var observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.initSlider(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                root: null,
                threshold: 0.1,
            }
        );

        carousels.forEach((carousel) => {
            observer.observe(carousel);
        });
    },
};
